import React from 'react';
import LoadingInner from '../Loading';

export const LeagueSelector = ({
  leagues,
  selectedLeagueId,
  onLeagueChange,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <LoadingInner />
    );
  }

  return (
    <div className="relative">

      <div className="flex overflow-x-auto whitespace-nowrap md:flex-wrap gap-2 pb-4">
        {leagues.map((league) => {
          const isActive = league.id === selectedLeagueId;
          return (
            <button
              key={league.id}
              onClick={() => onLeagueChange(league)}
              className={`
                hover:brightness-110 px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200
                ${
                  isActive
                    ? "bg-[var(--theme-primary)] text-white font-semibold"
                    : "bg-[var(--theme-bg)] text-[var(--theme-text)] font-medium"
                }
              `}
            >
              {league.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};
